import React from 'react';
import { AuditPlan } from '../types';

interface AuditPlanTabProps {
  plans: AuditPlan[];
  loading: boolean;
  onOpenCreate: () => void;
}

export const AuditPlanTab: React.FC<AuditPlanTabProps> = ({
  plans,
  loading,
  onOpenCreate,
}) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      <div className="card" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '16px' }}>
        <div>
          <h2 style={{ fontSize: '18px', fontWeight: 700, color: '#0f172a', margin: '0 0 4px 0' }}>
            Periodic Audit Plans
          </h2>
          <p style={{ fontSize: '13px', color: '#64748b', margin: 0 }}>
            Quarterly (Q1-Q4) and monthly operational audit implementation plans.
          </p>
        </div>
        <button
          onClick={onOpenCreate}
          className="btn-primary"
          style={{ width: 'auto', padding: '8px 16px', fontSize: '13px', display: 'inline-flex', alignItems: 'center', gap: '6px' }}
        >
          <span>+ New Periodic Plan</span>
        </button>
      </div>

      {!loading && plans.length === 0 ? (
        <div className="card" style={{ padding: '48px', textAlign: 'center', color: '#64748b' }}>
          No periodic audit plans registered.
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(360px, 1fr))', gap: '16px' }}>
          {plans.map((p) => (
            <div
              key={p.id}
              className="card"
              style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <span style={{ fontFamily: 'monospace', fontSize: '12px', fontWeight: 700, color: '#0284c7', background: '#e0f2fe', padding: '2px 8px', borderRadius: '4px' }}>
                  {p.planNumber}
                </span>
                <span className="badge-pill badge-success">
                  {p.status}
                </span>
              </div>
              <h3 style={{ fontWeight: 700, color: '#0f172a', fontSize: '16px', margin: 0 }}>{p.title}</h3>
              <div style={{ fontSize: '12px', color: '#64748b', display: 'flex', flexDirection: 'column', gap: '4px' }}>
                <div>Period: <span style={{ fontWeight: 600, color: '#334155' }}>{p.period}</span></div>
                <div>Lead Planner: <span style={{ fontWeight: 600, color: '#334155' }}>{p.leadPlannerId}</span></div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
